import { createContext } from 'react'

export type ControlButtonContext = {
  onHandleClick: (action: 1 | -1) => void
}

export const ControlButtonContext = createContext<ControlButtonContext>({
  onHandleClick: () => {},
})
